import moment from "moment";
import { textLengths } from "../../../../redux/Types";
import { validateEmail } from "util/validations/UserActionsValidation";

export const ValidateContacts = (data) => {
    let errors = {}

    if (data && data.contacts) {
        data = data.contacts;
        if (!data.name) {
            errors.name = "Name should not be empty";
        } else if (data.name && data.name.length > textLengths.TEXT) {
            errors.name = "Sorry, the name you entered is too long. Please try a shorter name";
        }
        if (!data.companyName) {
            errors.companyName = "Company name should not be empty";
        } else if (data.companyName && data.companyName.length > textLengths.TEXT) {
            errors.companyName = "Sorry, the company name you entered is too long. Please try a shorter company name";
        }
        if (!data.companyType) {
            errors.companyType = "Company type should not be empty";
        }
        if (validateEmail(data.email)) {
            errors.email = validateEmail(data.email);
        }
    }


    if (Object.entries(errors).length === 0) {
        return null;
    } else {
        return errors;
    }
}